export default __webpack_public_path__ + "static/B0210-f9062d9753a455f60c2842366b68f503.png";